document.addEventListener("DOMContentLoaded", function () {

    function updateFilterCount() {
        let filterEl = document.querySelector('.filters_applied');
        const divisor = document.querySelector('.filter-divisor');

        if (!filterEl && divisor) {
            filterEl = document.createElement('div');
            filterEl.className = 'filters_applied';
            filterEl.textContent = '1';
            divisor.parentNode.insertBefore(filterEl, divisor);
            filterEl.dataset.updated = true;
        } else if (filterEl) {
            if(filterEl.dataset.updated) return
            const current = parseInt(filterEl.textContent.trim(), 10);
            filterEl.textContent = isNaN(current) ? '1' : (current + 1).toString();
            filterEl.dataset.updated = true;
        }

    }

    function sortPLPCards(applyOffset = false) {
        // Live NodeList (important for accurate DOM)
        const allItems = Array.from(document.querySelectorAll('.js-plp-item'));
        // Get updated list without cards (only true PLP items)
        const availableProducts = Array.from(document.querySelectorAll('.js-plp-item:not(.plp-card):not(.product-not-available)'));

        // Save plp-cards with their original DOM index
        const cards = allItems
            .map((item) => ({ index: item.dataset.index, item }))
            .filter(({ item }) => item.classList.contains('plp-card'));

        // Remove the cards from DOM
        cards.forEach(({ item }) => item.remove());
        let cardsInserted = 0

        cards.forEach(({ index, item }) => {
            let offset = 0;

            const targetIndex = index - 1;
            const referenceNode = availableProducts[targetIndex];

            if (referenceNode) {
                item.style.display = "block";
                referenceNode.parentNode.insertBefore(item, referenceNode);
            } else {

                if (cardsInserted) {
                    item.style.display = "none";
                } else {
                    item.style.display = "block";
                }
                availableProducts[availableProducts.length - 1].parentNode.appendChild(item);

            }
            cardsInserted++;
        });
    }


    function isAvailabilityFilterOn() {
        const urlParams = new URLSearchParams(window.location.search);
        const filterAvailability = urlParams.has('show_only_available');

        const availabilityCheckbox = document.querySelector("#availability-filter-input");
        if (filterAvailability) {
            availabilityCheckbox.checked = true;
        }
        return filterAvailability
    }

    function updateItmesCount() {
        const itemsHidden = document.querySelectorAll(".product-not-available")?.length;
        const updateItmesCount = document.querySelector(".pagination-count");
        let updateItmesCountText = updateItmesCount.innerText;
        const areItemsHidden = isAvailabilityFilterOn()
        let firstMatchFound = false;

        updateItmesCountText = updateItmesCountText?.replace(/\b\d+\b/g, (match) => {
            if (!firstMatchFound) {
                firstMatchFound = true;
                return match;
            }
            const num = Number(match);
            if (areItemsHidden) return String(num - itemsHidden);
            return String(num + itemsHidden);
        });

        updateItmesCount.innerText = updateItmesCountText;
    }

    function togleUnavailableItems() {
        const filterValue = isAvailabilityFilterOn()
        if (!filterValue) return

        const notAvailableElements = document.querySelectorAll(".product-not-available");

        notAvailableElements.forEach(function (element) {

            if (filterValue) {
                element.style.display = "none";
            } else {
                element.style.display = "block";
            }
        });

        updateFilterCount()
        sortPLPCards(filterValue)
        updateItmesCount()

    }

    window.togleUnavailableItems = togleUnavailableItems;

    togleUnavailableItems();

});